/* BeBobi — popup upsell po dodaniu do koszyka.
   Słucha zdarzenia koszyka (cart:update z product-form / spotlightu),
   dobiera akcesoria z bebobi-upsell-map.json i — jeśli dodany produkt ma
   wzór (Kolor) — proponuje akcesoria w TYM SAMYM wzorze (wariant + zdjęcie). */
(function () {
  'use strict';
  var root = document.getElementById('bebobi-upsell');
  if (!root) return;
  var MAP_URL = root.dataset.mapUrl;
  var EN = (root.dataset.locale || 'pl') === 'en';
  var T = EN
    ? { add: 'Add', added: 'Added \u2713', inPattern: 'in your pattern: ' }
    : { add: 'Dodaj', added: 'Dodano \u2713', inPattern: 'w Twoim wzorze: ' };
  var MONEY = root.dataset.moneyFormat || '{{amount}} zł';
  var SOURCES = ['product-form-component', 'bebobi-spotlight'];
  var WZORY = ['bieGAJ', 'Countryside', 'Flower HAUer', 'HAU are you summer', 'Hippie Hound', 'MySkylos', 'PAWradise', 'PSYrenki', 'WestWOOF Story', 'Dog is in the air', 'FoggyTail', 'PineWalk', 'SandPaws'];
  var map = null;
  var productCache = {};
  var preorderCache = {};

  fetch(MAP_URL).then(function (r) { return r.json(); }).then(function (m) { map = m; }).catch(function () {});

  function money(cents) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    return MONEY.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v);
  }
  function norm(s) { return String(s || '').trim().toLowerCase(); }

  function getProduct(handle) {
    if (productCache[handle]) return productCache[handle];
    productCache[handle] = fetch('/products/' + handle + '.js').then(function (r) {
      if (!r.ok) throw new Error(handle);
      return r.json();
    });
    return productCache[handle];
  }

  /* przedsprzedaż (zatwierdzone przez Agę 10/2026): /products/{handle}.js nie podaje stanu ani polityki
     magazynowej, więc listę wariantów w przedsprzedaży + nazwę/wartość widocznej właściwości pozycji
     bierzemy z sections/bebobi-preorder-data.liquid (Section Rendering API, w języku sklepu).
     Ta sama reguła i teksty co na karcie produktu. Błąd = dodanie bez właściwości (jak dotąd). */
  function getPreorder(handle) {
    if (preorderCache[handle]) return preorderCache[handle];
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    preorderCache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '?section_id=bebobi-preorder-data', { headers: { Accept: 'text/html' } })
      .then(function (r) {
        if (!r.ok) throw new Error('preorder ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-bb-preorder]');
        var d = el ? JSON.parse(el.textContent || '{}') : null;
        return d && d.name && d.value && Array.isArray(d.ids) ? d : null;
      })
      .catch(function () { delete preorderCache[handle]; return null; });
    return preorderCache[handle];
  }

  /* dopasuj wariant akcesorium do wzoru dodanego produktu */
  function pickVariant(product, wzor) {
    var vs = product.variants || [];
    var match = null;
    if (wzor) {
      match = vs.find(function (v) {
        return v.available && (v.options || []).some(function (o) { return norm(o) === norm(wzor); });
      });
    }
    return match || vs.find(function (v) { return v.available; }) || vs[0];
  }
  function variantImage(product, variant) {
    if (variant && variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
    return (product.images && product.images[0]) || product.featured_image || '';
  }
  function imgUrl(src, w) {
    if (!src) return '';
    return src.replace(/(\.[a-z]{3,4})(\?|$)/, '_' + w + 'x$1$2');
  }

  function open(addedTitle, cards, wzor) {
    var el = root;
    el.querySelector('[data-up-added]').textContent = addedTitle;
    var badge = el.querySelector('[data-up-wzor]');
    if (wzor) { badge.textContent = T.inPattern + wzor; badge.hidden = false; }
    else badge.hidden = true;
    var list = el.querySelector('[data-up-list]');
    list.innerHTML = '';
    cards.forEach(function (c) {
      var li = document.createElement('div');
      li.className = 'bb-up__card';
      li.innerHTML =
        '<img src="' + imgUrl(c.image, 360) + '" alt="" loading="lazy" width="180" height="225">' +
        '<div class="bb-up__meta"><div class="bb-up__name"></div><div class="bb-up__price">' + money(c.price) + '</div></div>' +
        '<button type="button" class="bb-up__add" data-variant="' + c.variantId + '" data-handle="' + c.handle + '">' + T.add + '</button>';
      li.querySelector('.bb-up__name').textContent = c.title;
      list.appendChild(li);
    });
    el.classList.add('is-open');
    document.documentElement.classList.add('bb-up-lock');
  }
  function close() {
    root.classList.remove('is-open');
    document.documentElement.classList.remove('bb-up-lock');
  }
  root.addEventListener('click', function (e) {
    if (e.target.matches('[data-up-close], .bb-up__backdrop')) close();
    var btn = e.target.closest('.bb-up__add');
    if (btn && !btn.disabled) addUpsell(btn);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  function addUpsell(btn) {
    btn.disabled = true;
    var orig = btn.textContent;
    btn.textContent = '…';
    var sectionIds = Array.prototype.map.call(document.querySelectorAll('cart-items-component'), function (el) { return el.dataset.sectionId; }).filter(Boolean);
    var item = { id: Number(btn.dataset.variant), quantity: 1 };
    (btn.dataset.handle ? getPreorder(btn.dataset.handle) : Promise.resolve(null)).then(function (pre) {
      if (pre && pre.ids.map(String).indexOf(String(item.id)) !== -1) {
        item.properties = {};
        item.properties[pre.name] = pre.value;
      }
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [item], sections: sectionIds.join(','), sections_url: window.location.pathname }),
      });
    }).then(function (r) { return r.json(); }).then(function (data) {
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        try {
          // odśwież koszyk motywu bez otwierania kolejnego popupu
          import('@theme/events').then(function (ev) {
            document.dispatchEvent(new ev.CartAddEvent(cart, 'bebobi-upsell', { source: 'bebobi-upsell', itemCount: cart.item_count, sections: data.sections }));
          }).catch(function () {});
        } catch (_) {}
        btn.textContent = T.added;
        btn.classList.add('is-added');
      });
    }).catch(function () { btn.disabled = false; btn.textContent = orig; });
  }

  document.addEventListener('cart:update', function (e) {
    var d = (e.detail && e.detail.data) || {};
    if (SOURCES.indexOf(d.source) === -1) return;
    if (!map) return;
    var cart = e.detail.resource;
    var item = cart && cart.items && cart.items[0];
    if (!item || !item.handle) return;
    var handles = map[item.handle];
    if (!handles || !handles.length) return;
    // wzór dodanego produktu (jeśli ma opcję z listy wzorów)
    var wzor = null;
    (item.variant_options || item.options_with_values || []).forEach(function (o) {
      var val = typeof o === 'string' ? o : o.value;
      if (WZORY.some(function (w) { return norm(w) === norm(val); })) wzor = val;
    });
    Promise.all(handles.slice(0, 3).map(function (h) {
      return getProduct(h).then(function (p) {
        var v = pickVariant(p, wzor);
        if (!v) return null;
        getPreorder(h); // pobierz z wyprzedzeniem, żeby "Dodaj" nie czekało
        return { title: p.title.replace(/\s*[-–—]\s*KOLORY.*$/i, ''), price: v.price, variantId: v.id, handle: h, image: variantImage(p, v) };
      }).catch(function () { return null; });
    })).then(function (cards) {
      cards = cards.filter(Boolean);
      if (cards.length) open(item.product_title, cards, wzor);
    });
  });
})();
